import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { useEffect } from "react";

// Pages
import HomePage from "@/pages/HomePage";
import ServicesPage from "@/pages/ServicesPage";
import GalleryPage from "@/pages/GalleryPage";
import AboutPage from "@/pages/AboutPage";
import ContactPage from "@/pages/ContactPage";
import AdminPage from "@/pages/AdminPage";

// Layout
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

// CTA Interaction System
import { useCtaInteractionSystem } from "@/hooks/useCtaInteraction";

// Google Analytics 4 initialization
const initGA4 = () => {
  const measurementId = process.env.REACT_APP_GA_MEASUREMENT_ID;
  
  if (!measurementId) {
    console.log("GA4: No measurement ID configured - analytics disabled");
    return;
  }

  // Load gtag.js script
  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
  document.head.appendChild(script);

  // Initialize gtag
  window.dataLayer = window.dataLayer || [];
  function gtag() {
    window.dataLayer.push(arguments);
  }
  window.gtag = gtag;
  gtag("js", new Date());
  gtag("config", measurementId);
  
  console.log(`GA4: Initialized with measurement ID ${measurementId}`);
};

// Page wrapper for transitions
const PageWrapper = ({ children }) => {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
    
    // Track page views in GA4
    if (window.gtag) {
      window.gtag("event", "page_view", {
        page_path: location.pathname,
        page_title: document.title,
      });
    }
  }, [location.pathname]);

  return <div className="page-transition">{children}</div>;
};

// Routes with transitions
const AppRoutes = () => {
  return (
    <PageWrapper>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/ydelser" element={<ServicesPage />} />
        <Route path="/galleri" element={<GalleryPage />} />
        <Route path="/om-os" element={<AboutPage />} />
        <Route path="/kontakt" element={<ContactPage />} />
        <Route path="/admin" element={<AdminPage />} />
      </Routes>
    </PageWrapper>
  );
};

function App() {
  // Initialize GA4 on app mount
  useEffect(() => {
    initGA4();
  }, []);

  // Initialize CTA interaction system for premium touch/hover effects
  useCtaInteractionSystem();

  return (
    <div className="App min-h-screen flex flex-col">
      <BrowserRouter>
        <Navbar />
        <main className="flex-1">
          <AppRoutes />
        </main>
        <Footer />
        <Toaster position="top-right" />
      </BrowserRouter>
    </div>
  );
}

export default App;
